export enum EstadoCivil {
  CASADO = 'CASADO',
  DIVORCIADO = 'DIVORCIADO',
  SEPARADO = 'SEPARADO',
  SOLTEIRO = 'SOLTEIRO',
  VIUVO = 'VIUVO',
}
